import React, { useState } from "react";
import "./BookConsultationStyle.css";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";

const BookConsultation = ({ id }) => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    services: [],
    message: "",
    time: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => {
        const services = checked
          ? [...prev.services, value]
          : prev.services.filter((service) => service !== value);
        return { ...prev, services };
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.services.length === 0) {
      alert(t("bookConsultation.errorNoService"));
      return;
    }

    setIsLoading(true);

    const currentTime = new Date().toLocaleString("en-US", {
      dateStyle: "medium",
      timeStyle: "short",
    });

    const templateParams = {
      name: formData.name,
      mobileNumber: formData.mobileNumber,
      services: formData.services.join(", "),
      time: currentTime,
    };

    if (formData.email.trim() !== "") {
      templateParams.email = formData.email;
    }
    if (formData.message.trim() !== "") {
      templateParams.message = formData.message;
    }

    emailjs
      .send(
        "service_poygktb",
        "template_knkzvza",
        templateParams,
        "Q3gpPHks7_bDU2Jgz"
      )
      .then(
        (result) => {
          alert(t("bookConsultation.successMessage"));
          setFormData({
            name: "",
            mobileNumber: "",
            email: "",
            services: [],
            message: "",
            time: "",
          });
          setIsLoading(false);
        },
        (error) => {
          alert(t("bookConsultation.errorMessage"));
          setIsLoading(false);
        }
      );
  };

  return (
    <section
      className={`booking-container ${i18n.dir() === "rtl" ? "rtl" : ""}`}
      id={id}
    >
      <h2 className="booking-headline">
        {t("bookConsultation.headline.prefix")}{" "}
        <span style={{ color: "#ff6b6b" }}>
          {t("bookConsultation.headline.transformation")}
        </span>
      </h2>
      <div id="consultation-form" className="booking-form">
        <h3 className="booking-form-title">
          {t("bookConsultation.formTitle")}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="booking-field">
            <label htmlFor="name">{t("bookConsultation.form.name")}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              autoComplete="name"
            />
          </div>
          <div className="booking-field">
            <label htmlFor="mobileNumber">
              {t("bookConsultation.form.mobileNumber")}
            </label>
            <input
              type="tel"
              id="mobileNumber"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleChange}
              required
              autoComplete="tel"
            />
          </div>
          <div className="booking-field">
            <label htmlFor="email">{t("bookConsultation.form.email")}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
            />
          </div>
          <div className="booking-field">
            <fieldset>
              <legend>{t("bookConsultation.form.services")}</legend>
              <div className="booking-checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="services"
                    value="Full Marketing Strategy"
                    checked={formData.services.includes(
                      "Full Marketing Strategy"
                    )}
                    onChange={handleChange}
                  />
                  {t("bookConsultation.form.options.fullMarketingStrategy")}
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="services"
                    value="Full Marketing Plan"
                    checked={formData.services.includes("Full Marketing Plan")}
                    onChange={handleChange}
                  />
                  {t("bookConsultation.form.options.fullMarketingPlan")}
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="services"
                    value="Media Production"
                    checked={formData.services.includes("Media Production")}
                    onChange={handleChange}
                  />
                  {t("bookConsultation.form.options.mediaProduction")}
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="services"
                    value="Designing & Motions"
                    checked={formData.services.includes("Designing & Motions")}
                    onChange={handleChange}
                  />
                  {t("bookConsultation.form.options.designingMotions")}
                </label>
              </div>
            </fieldset>
          </div>
          <div className="booking-field">
            <label htmlFor="message">
              {t("bookConsultation.form.message")}
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              autoComplete="message"
            />
          </div>
          <button type="submit" className="booking-submit" disabled={isLoading}>
            {isLoading
              ? t("bookConsultation.submitting")
              : t("bookConsultation.submit")}
          </button>
          {isLoading && (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <span>{t("bookConsultation.loading")}</span>
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default BookConsultation;
